import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { productTabSearchInitState } from './state';

export const productTabSearchSlice = createSlice({
    name: `productTabSearchSlice`,
    initialState: productTabSearchInitState,
    reducers: {
        initProductTabSearchSlice: () => {
            return {
                ...productTabSearchInitState,
            };
        },
        updateProductTabSearchCondition: (state, action: PayloadAction<{ key: string; value: string }>) => {
            state[action.payload.key] = action.payload.value;
        },
    },
});

export const { initProductTabSearchSlice, updateProductTabSearchCondition } = productTabSearchSlice.actions;
export default productTabSearchSlice.reducer;
